<template>
  <div class="rpt9Table">
    <Reporta9FristTotal
      class="my-2"
      :objectdata="{ data: gametotalItems }"
    ></Reporta9FristTotal>
    <lida-table
      v-for="(it, key) in totalData"
      @rowClick="$event => getCq9Detail($event, key)"
      :key="key"
      :propscolumns="columns(key)"
      :data="it"
      :sortStatus="false"
      align="right"
      :SpinLoading="loading"
      :propsPageSize="50"
      :class="{ 'cq9-row': Number(query.gameid) > 100 }"
      :LeaveSpace="false"
      class="my-2"
      :ref="[`table${key}`]"
    >
      <template v-slot:headerSelect>
        <p class="title text-left">{{getGamename(key)}}</p>
      </template>
    </lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GameDetailedReport from '../mixins/game-detailed-report'
import switchHie from "../mixins/switchHie.js"
import totalData from '@/plugins/utils/table-total-data'
import reportCount from '@/mixins/report-count.js'

export default {
  name: 'reporta9',
  mixins: [GameDetailedReport, switchHie, reportCount],
  components: {
    Reporta9FristTotal: () => import("../components/Reporta9FristTotal")
  },
  data () {
    return {
      totalData: {},
      gametotalItems: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
  },
  created () {
    this.getTableData()
  },
  methods: {
    async getTableData () {
      this.loading = true
      try {
        const data = {
          ...this.query,
          stid: this.query.stidlist || this.query.stid,
          repnum: 9,
          seekdate: this.query.date
        }
        const res = await this.$axios.generalLedger.linkreporta2_9(data)
        if ('status' in res && res.status === 0) return
        Object.keys(res).forEach(it => { // 塞入全部報表 派彩金額 計算使用
          res[it] = res[it].map(item => {
            if (it == 101) {
              item["bonuswin"] = item["bonus"]
            } else if (it != 101 && it > 100) {
              item["bonuswin"] = item["win"]
            } else {
              item["bonuswin"] = 0
            }
            return item
          }).sort((a, b) => b.betcalid - a.betcalid)
        });
        this.gametotalItems = res
        this.totalData = res
        Object.keys(res).forEach(it => {
          this.totalArr[it] = totalData(this.totalData[it], { yokekka: '', lpds: '' })
        });
      } catch (error) {
        console.error(error);
        this.checkUrl(error)
      } finally {
        this.loading = false 
      }
    },
    async getCq9Detail (data, gameid) { // CQ9注单明细
      try {
        if ([128, 130].some(it => it === Number(gameid))) return // yeebet poly沒細單
        if (!this.judgeExgame(Number(gameid)) || data.betcalid == '') return
        const raw = {
          round: data.betcalid,
          date: data.date.split(' ')[0],
          mid: this.query.mid,
          gamecode: data.deoddsrepname,
          stid: this.query.stidlist || this.query.stid,
          gameid
        }
        const res = await this.$axios.generalLedger.linkorderdetail_cq9(raw)
        if (res.length == 0) return
        window.open(res[0].data.data, "_blank")
      } catch (error) {
        console.error(error)
      }
    },
    judgeExgame(gameid) { // 判斷外站遊戲
      return gameid >= 101 && gameid <= 200
    }
  }
}
</script>

<style lang="scss">
.rpt9Table {
  .cq9-row tr:not(:last-of-type) {
    cursor: pointer;
  }
}
</style>